module.exports = {
          srcSet: __webpack_public_path__ + "c5e446a4981501a5e69cf15bb522e07e-2336.png"+" 2336w",
          images:[ {path: __webpack_public_path__ + "c5e446a4981501a5e69cf15bb522e07e-2336.png",width: 2336,height: 396}],
          src: __webpack_public_path__ + "c5e446a4981501a5e69cf15bb522e07e-2336.png",
          toString:function(){return __webpack_public_path__ + "c5e446a4981501a5e69cf15bb522e07e-2336.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAIAAADuA9qHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAASUlEQVR4nAE+AMH/AOR7/dF/5rJ6z6+C0L2L59J7v9F2nOWfttiXefWYOQDGJ/K7NumdTM6XX8OjZdS1YpzBaJ/Shd3PipPsjJvi2CdITq/iuQAAAABJRU5ErkJggg==",
          width: 2336,
          height: 396
        }